import React from "react";
import PropTypes from "prop-types";
import { Popover, Input, Tabs, Form, Radio, Tooltip } from "antd";

import QuarterlyMonth, { maxNumMonthElements } from "./QuarterlyMonth";
import YearlyMonth from "./YearlyMonth";
import LastDay from "./LastDay";
import DateOfMonth from "./DateOfMonth";
import {
  getScheduleContent,
  getMaxScheduleCount,
  QUARTERLY,
  BIANNUALLY,
  YEARLY,
  MONTHLY,
} from "../../../utils/report";

const generateDefaultConfig = (reportType, scheduleTriggerType) => {
  return new Array(getMaxScheduleCount(reportType)).fill({}).map(() => {
    const defaultConfig = {};
    switch (scheduleTriggerType) {
      case 3:
        defaultConfig.date = 1;
        break;
      case 4:
        defaultConfig.week = 1;
        defaultConfig.day = "Monday";
        break;
      default:
    }
    switch (reportType) {
      case QUARTERLY:
      case BIANNUALLY:
      case YEARLY:
        defaultConfig.month = 1;
        break;
      default:
    }
    return defaultConfig;
  });
};

const generateSingleSchedule = (props) => {
  const { record, updateField, invalidField, index } = props;
  // TODO: need to re-factor
  let monthselect = null;
  // define month select element
  switch (record.shedule_type) {
    case QUARTERLY:
      monthselect = (
        <QuarterlyMonth
          value={record.schedule_trigger_data?.[index]?.month}
          onChange={(e) => {
            let scheduleWeekday = generateDefaultConfig(
              record.shedule_type,
              record.schedule_trigger_type,
            );
            if (record.schedule_trigger_data?.length > 0) {
              scheduleWeekday = record.schedule_trigger_data;
            }
            scheduleWeekday[index].month = e.target.value;
            updateField(scheduleWeekday);
          }}
          monthCount={maxNumMonthElements(record.shedule_type)}
        />
      );
      break;
    case BIANNUALLY:
    case YEARLY:
      monthselect = (
        <YearlyMonth
          value={record.schedule_trigger_data?.[index]?.month}
          onChange={(e) => {
            let scheduleWeekday = generateDefaultConfig(
              record.shedule_type,
              record.schedule_trigger_type,
            );
            if (record.schedule_trigger_data?.length > 0) {
              scheduleWeekday = record.schedule_trigger_data;
            }
            scheduleWeekday[index].month = e;
            updateField(scheduleWeekday);
          }}
        />
      );
      break;
    default:
      monthselect = null;
  }

  let innerElement = null;
  switch (record.schedule_trigger_type) {
    case 3:
      innerElement = (
        <Form.Item label="Date">
          <DateOfMonth
            value={record.schedule_trigger_data?.[index]?.date}
            onChange={(e) => {
              let scheduleWeekday = generateDefaultConfig(
                record.shedule_type,
                record.schedule_trigger_type,
              );
              if (record.schedule_trigger_data?.length > 0) {
                scheduleWeekday = record.schedule_trigger_data;
              }
              scheduleWeekday[index].date = e;
              updateField(scheduleWeekday);
            }}
            reportType={record.shedule_type}
            month={record.schedule_trigger_data?.[index]?.month}
          >
            {[QUARTERLY, MONTHLY].includes(
              record.shedule_type,
            ) ? (
              <LastDay
                checked={
                  record.schedule_trigger_data?.[index]?.date === "lastday"
                }
                onChange={(e) => {
                  let scheduleWeekday = generateDefaultConfig(
                    record.shedule_type,
                    record.schedule_trigger_type,
                  );
                  if (record.schedule_trigger_data?.length > 0) {
                    scheduleWeekday = record.schedule_trigger_data;
                  }
                  scheduleWeekday[index].date = e.target.value;
                  updateField(scheduleWeekday);
                }}
              />
            ) : null}
          </DateOfMonth>
        </Form.Item>
      );
      break;
    case 4:
      innerElement = (
        <>
          <Form.Item label="Week">
            <Radio.Group
              value={record.schedule_trigger_data?.[index]?.week}
              buttonStyle="solid"
              onChange={(e) => {
                let scheduleWeekday = generateDefaultConfig(
                  record.shedule_type,
                  record.schedule_trigger_type,
                );
                if (record.schedule_trigger_data?.length > 0) {
                  scheduleWeekday = record.schedule_trigger_data;
                }
                scheduleWeekday[index].week = e.target.value;
                updateField(scheduleWeekday);
              }}
            >
              <Radio.Button value={1}>Week 1</Radio.Button>
              <Radio.Button value={2}>Week 2</Radio.Button>
              <Radio.Button value={3}>Week 3</Radio.Button>
              <Radio.Button value={4}>Week 4</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="Day">
            <Radio.Group
              value={record.schedule_trigger_data?.[index]?.day}
              name="radiogroup"
              onChange={(e) => {
                let scheduleWeekday = [
                  { month: 1, week: 1, day: "Monday" },
                  { month: 1, week: 1, day: "Monday" },
                ];
                if (record.schedule_trigger_data?.length > 0) {
                  scheduleWeekday = record.schedule_trigger_data;
                }
                scheduleWeekday[index].day = e.target.value;
                updateField(scheduleWeekday);
              }}
            >
              <Radio value="Monday">M</Radio>
              <Radio value="Tuesday">T</Radio>
              <Radio value="Wednesday">W</Radio>
              <Radio value="Thursday">T</Radio>
              <Radio value="Friday">F</Radio>
              <Radio value="Saturday">S</Radio>
              <Radio value="Sunday">S</Radio>
            </Radio.Group>
          </Form.Item>
        </>
        // <WeekOfMonth
        //   week={record.schedule_trigger_data?.[index]?.week}
        //   day={record.schedule_trigger_data?.[index]?.day}
        //   changeWeekHandler={(e) => {
        //     let scheduleWeekday = generateDefaultConfig(
        //       record.shedule_type,
        //       record.schedule_trigger_type,
        //     );
        //     if (record.schedule_trigger_data?.length > 0) {
        //       scheduleWeekday = record.schedule_trigger_data;
        //     }
        //     scheduleWeekday[index].week = e.target.value;
        //     updateField(scheduleWeekday);
        //   }}
        //   changeDayHandler={(e) => {
        //     let scheduleWeekday = [
        //       { month: 1, week: 1, day: "Monday" },
        //       { month: 1, week: 1, day: "Monday" },
        //     ];
        //     if (record.schedule_trigger_data?.length > 0) {
        //       scheduleWeekday = record.schedule_trigger_data;
        //     }
        //     scheduleWeekday[index].day = e.target.value;
        //     updateField(scheduleWeekday);
        //   }}
        // />
      );
      break;
    default:
      return null;
  }
  return (
    <>
      <Form.Item label="Month">{monthselect}</Form.Item>
      {innerElement}
    </>
  );
};

const ScheduleElementObj = (props) => {
  const { record, updateField, invalidField } = props;
  // const popOverContent = [];
  // for (
  //   let index = 0;
  //   index < getMaxScheduleCount(record.shedule_type);
  //   index++
  // ) {
  //   popOverContent.push(generateSingleSchedule({ ...props, index: index }));
  // }

  // define schedule input element
  let scheduleInput = null;
  // if (
  //   record.schedule_trigger_type === 1 ||
  //   record.schedule_trigger_type === 2
  // ) {
  scheduleInput = (
    <Tooltip title={`${getScheduleContent(record)}`}>
      <Input
        status={invalidField ? "error" : ""}
        placeholder="Please Select Schedule"
        value={getScheduleContent(record)}
      />
    </Tooltip>
  );
  // }

  return (
    <Popover
      // content={<Space direction="vertical">{popOverContent}</Space>}
      content={
        <Tabs
          defaultActiveKey="0"
          tabPosition="left"
          style={{ minWidth: 500 }}
          items={new Array(getMaxScheduleCount(record.shedule_type))
            .fill(null)
            .map((_, i) => {
              return {
                label: `Schedule ${i + 1}`,
                key: String(i),
                children: (
                  <Form labelCol={{ span: 4 }}>
                    {generateSingleSchedule({ ...props, index: i })}
                  </Form>
                ),
              };
            })}
        />
      }
      trigger="click"
    >
      {scheduleInput}
    </Popover>
  );
};
ScheduleElementObj.defaultProps = {
  invalidField: false,
};

ScheduleElementObj.propTypes = {
  record: PropTypes.shape({
    schedule_trigger_type: PropTypes.number.isRequired,
    shedule_type: PropTypes.string.isRequired,
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  invalidField: PropTypes.bool,
};

export default ScheduleElementObj;
